<mat-toolbar class="st-main-content-top-bar-container">
    <mat-toolbar-row>
        @if (mainCta$()) {
            <div class="st-main-content-top-bar-main-cta">
                @switch (mainCta$()) {
                    @case (listMainCtaType.PLAYBOOK) {
                        <st-playbook-main-cta />
                    }
                    @case (listMainCtaType.CAST) {
                        <st-cast-main-cta />
                    }
                    @case (listMainCtaType.LIVE) {
                        <st-live-main-cta />
                    }
                    @case (listMainCtaType.TEAM_MEMBERS) {
                        <st-manage-team-members-main-cta />
                    }
                    @case (listMainCtaType.PUBLICATION_CHANNELS) {
                        <st-manage-publication-channels-main-cta />
                    }
                    @case (listMainCtaType.PLANNING_VIEWS) {
                        <st-planning-views-main-cta />
                    }
                }
            </div>
        }
        @if (secondaryCta$()) {
            <div class="st-main-content-top-bar-secondary-cta">
                @switch (secondaryCta$()) {
                    @case (listMainCtaType.PLAYBOOK) {
                        <st-playbook-secondary-cta />
                    }
                    @case (listMainCtaType.CAST) {
                        <st-cast-secondary-cta />
                    }
                    @case (listMainCtaType.DISCOVER) {
                        <st-discover-secondary-cta />
                    }
                    @case (listMainCtaType.LIVE) {
                        <st-live-secondary-cta />
                    }
                    @case (listMainCtaType.TEMPLATES) {
                        <st-templates-secondary-cta />
                    }
                }
            </div>
        }
        @if (viewOptions$()) {
            <div class="st-main-content-top-bar-view-options">
                @switch (viewOptions$()) {
                    @case (listMainCtaType.PLAYBOOK) {
                        <st-playbook-view-options />
                    }
                    @case (listMainCtaType.DISCOVER) {
                        <st-discover-view-options />
                    }
                    @case (listMainCtaType.LIVE) {
                        <st-live-view-options />
                    }
                    @case (listMainCtaType.WASTEBIN) {
                        <st-wastebin-view-options />
                    }
                    @case (listMainCtaType.TEMPLATES) {
                        <st-templates-view-options />
                    }
                    @case (listMainCtaType.TEAM_MEMBERS) {
                        <st-manage-team-members-view-options />
                    }
                }
            </div>
        }
        @if (rightSlot$()) {
            <div class="st-main-content-top-bar-right-slot">
                @switch (rightSlot$()) {
                    @case (listMainCtaType.PLAYBOOK) {
                        <st-playbook-right-slot />
                    }
                    @case (listMainCtaType.CAST) {
                        <st-cast-right-slot />
                    }
                    @case (listMainCtaType.DISCOVER) {
                        <st-discover-right-slot />
                    }
                    @case (listMainCtaType.TEAM_MEMBERS) {
                        <st-manage-team-members-right-slot />
                    }
                }
            </div>
        }
    </mat-toolbar-row>
</mat-toolbar>
